export default "__VITE_ASSET__BeZIhQHw__"